import { useState, useRef, useEffect } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const AUTOSAVE_DELAY_MS = 600;
export function InlineEditInput({
  value: initialValue = '',
  onSubmit,
  onAutoSave,
  onCancel,
  placeholder,
  typography,
  dataTestId
}) {
  const [value, setValue] = useState(initialValue);
  const debounceTimerRef = useRef(null);
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);
  const handleChange = e => {
    const newValue = e.target.value;
    setValue(newValue);
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // onAutoSave fires in the background without exiting edit mode,
    // while onSubmit handles immediate save + exit on blur/Enter
    if (onAutoSave && newValue.trim()) {
      debounceTimerRef.current = setTimeout(() => {
        onAutoSave(newValue.trim());
        debounceTimerRef.current = null;
      }, AUTOSAVE_DELAY_MS);
    }
  };
  const handleSubmit = () => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }
    if (value.trim()) {
      onSubmit(value.trim());
    } else {
      onCancel();
    }
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleSubmit();
    } else if (event.key === 'Escape') {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = null;
      }
      onCancel();
    }
  };
  const handleSelectText = event => {
    event.currentTarget.select();
  };
  return /*#__PURE__*/_jsx(FormControl, {
    displayOptimized: true
    // @ts-ignore borderBlockEndColor does not exist on FormControl, but it does
    ,
    borderBlockEndColor: "border-core-default",
    flexGrow: 1,
    children: /*#__PURE__*/_jsx(TextInput, {
      autoFocus: true,
      borderRadius: "0",
      value: value,
      typography: typography,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onFocus: handleSelectText,
      onClick: handleSelectText,
      onBlur: handleSubmit,
      placeholder: placeholder,
      "data-test-id": dataTestId
    })
  });
}